var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1623,
    height: 546,
    viewBox: "0 0 1623 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 415C118.649 308.431 299.647 83.5053 735.64 232.31C1171.63 381.114 1484.65 112.972 1622 1",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 425C118.649 318.431 299.647 93.5053 735.64 242.31C1171.63 391.114 1484.65 122.972 1622 11",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 435C118.649 328.431 299.647 103.505 735.64 252.31C1171.63 401.114 1484.65 132.972 1622 21",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 445C118.649 338.431 299.647 113.505 735.64 262.31C1171.63 411.114 1484.65 142.972 1622 31",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 455C118.649 348.431 299.647 123.505 735.64 272.31C1171.63 421.114 1484.65 152.972 1622 41",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 465C118.649 358.431 299.647 133.505 735.64 282.31C1171.63 431.114 1484.65 162.972 1622 51",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 475C118.649 368.431 299.647 143.505 735.64 292.31C1171.63 441.114 1484.65 172.972 1622 61",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 485C118.649 378.431 299.647 153.505 735.64 302.31C1171.63 451.114 1484.65 182.972 1622 71",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 495C118.649 388.431 299.647 163.505 735.64 312.31C1171.63 461.114 1484.65 192.972 1622 81",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 505C118.649 398.431 299.647 173.505 735.64 322.31C1171.63 471.114 1484.65 202.972 1622 91",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1 515C118.649 408.431 299.647 183.505 735.64 332.31C1171.63 481.114 1484.65 212.972 1622 101",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 525C118.649 418.431 299.647 193.505 735.64 342.31C1171.63 491.114 1484.65 222.972 1622 111",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 535C118.649 428.431 299.647 203.505 735.64 352.31C1171.63 501.114 1484.65 232.972 1622 121",
    stroke: "#AADBDD",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1 545C118.649 438.431 299.647 213.505 735.64 362.31C1171.63 511.114 1484.65 242.972 1622 131",
    stroke: "#AADBDD",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.e2fd65ca7e54a407db0f3045fa2f90f2.svg";
export { ForwardRef as ReactComponent };